import { useMemo } from "react";
import { isActiveBooking, todayKey } from "../../../Booking/bookingService";
import { splitShopResources } from "../../../Booking/bookingPlans";

export function shopNameOf(shops, id) {
    return shops.find((s) => s.id === id)?.business || "(removed shop)";
}

export function resourceNameOf(resources, id) {
    return resources.find((r) => r.id === id)?.name || "(deleted)";
}

export function typeNameOf(types, id) {
    return types.find((t) => t.id === id)?.name || "(deleted type)";
}

export function statusTone(status) {
    switch (status) {
        case "confirmed": return "green";
        case "pending": return "amber";
        case "completed": return "blue";
        case "cancelled": return "zinc";
        case "noshow": return "red";
        case "active": return "green";
        case "suspended": return "red";
        default: return "zinc";
    }
}

export function useShopStats(shops, resources, bookings, plans) {
    return useMemo(() => {
        const byShop = {};
        const tk = todayKey();
        for (const shop of shops) {
            const mine = bookings.filter((b) => b.ownerId === shop.id);
            const active = mine.filter(isActiveBooking);
            const { limit, locked } = splitShopResources(shop, resources, plans);
            byShop[shop.id] = {
                total: mine.length,
                active: active.length,
                pending: mine.filter((b) => b.status === "pending").length,
                upcoming: active.filter((b) => b.date >= tk).length,
                resources: resources.filter((r) => r.ownerId === shop.id).length,
                limit,
                locked: locked.length,
            };
        }
        return byShop;
    }, [shops, resources, bookings, plans]);
}

export function usePlatformStats(shops, resources, bookings) {
    return useMemo(() => ({
        shops: shops.length,
        activeShops: shops.filter((s) => s.status === "active").length,
        proShops: shops.filter((s) => s.plan === "pro").length,
        resources: resources.length,
        bookings: bookings.length,
        pending: bookings.filter((b) => b.status === "pending").length,
        active: bookings.filter(isActiveBooking).length,
    }), [shops, resources, bookings]);
}

